import React from 'react';
import FormDataProvider from 'integrations/contexts/FormDataProvider';

import { SidebarProvider } from './context/Sidebar';
import { StepsProvider } from './context/Steps';
import { AdvancedOptionsProvider } from './context/AdvancedOptions';
import Gmail from './Gmail';
import INITIAL_FORMDATA from './_initialFormData';
import { toGenericInputCreateRequest } from './common/formDataAdapter';

type Props = {
  onSubmit?: (InputCreateRequest) => void;
};

const EmbeddedGmailApp = ({ onSubmit = undefined }: Props) => {
  const handleSubmit = (formData) => {
    if (!onSubmit) {
      return;
    }

    onSubmit(toGenericInputCreateRequest(formData));
  };

  return (
    <StepsProvider>
      <FormDataProvider initialFormData={INITIAL_FORMDATA}>
        <SidebarProvider>
          <AdvancedOptionsProvider>
            <Gmail onSubmit={handleSubmit} externalInputSubmit={typeof onSubmit === 'function'} />
          </AdvancedOptionsProvider>
        </SidebarProvider>
      </FormDataProvider>
    </StepsProvider>
  );
};

export default EmbeddedGmailApp;
